import {
  GET_ACADEMIC_YEARS,
  GET_ACADEMIC_YEARS_FAIL,
  GET_ACADEMIC_YEARS_SUCCESS,
  ADD_NEW_ACADEMIC_YEAR,
  ADD_ACADEMIC_YEAR_SUCCESS,
  ADD_ACADEMIC_YEAR_FAIL,
  UPDATE_ACADEMIC_YEAR,
  UPDATE_ACADEMIC_YEAR_SUCCESS,
  UPDATE_ACADEMIC_YEAR_FAIL,
  DELETE_ACADEMIC_YEAR,
  DELETE_ACADEMIC_YEAR_SUCCESS,
  DELETE_ACADEMIC_YEAR_FAIL,


  GET_ACTIVE_ACADEMIC_YEARS,
    GET_ACTIVE_ACADEMIC_YEARS_SUCCESS,
    GET_ACTIVE_ACADEMIC_YEARS_FAIL
  
} from "./actionTypes";

export const getAcademicYears = () => ({
  type: GET_ACADEMIC_YEARS,
})

export const getAcademicYearsSuccess = academicYears => ({
  type: GET_ACADEMIC_YEARS_SUCCESS,
  payload: academicYears,
})

export const getAcademicYearsFail = error => ({
  type: GET_ACADEMIC_YEARS_FAIL,
  payload: error,
})

export const addNewAcademicYear = data => ({
  type: ADD_NEW_ACADEMIC_YEAR,
  payload: data,
})

export const addAcademicYearSuccess = academicYear => ({
  type: ADD_ACADEMIC_YEAR_SUCCESS,
  payload: academicYear,
})

export const addAcademicYearFail = error => ({
  type: ADD_ACADEMIC_YEAR_FAIL,
  payload: error,
})

export const updateAcademicYear = academicYear => ({
  type: UPDATE_ACADEMIC_YEAR,
  payload: academicYear,
})

export const updateAcademicYearSuccess = academicYear => ({
  type: UPDATE_ACADEMIC_YEAR_SUCCESS,
  payload: academicYear,
})

export const updateAcademicYearFail = error => ({
  type: UPDATE_ACADEMIC_YEAR_FAIL,
  payload: error,
})

export const deleteAcademicYear = data => ({
  type: DELETE_ACADEMIC_YEAR,
  payload: data,
})

export const deleteAcademicYearSuccess = data => ({
  type: DELETE_ACADEMIC_YEAR_SUCCESS,
  payload: data,
})

export const deleteAcademicYearFail = error => ({
  type: DELETE_ACADEMIC_YEAR_FAIL,
  payload: error,
})




export const getActiveAcademicYears = () => ({
    type: GET_ACTIVE_ACADEMIC_YEARS,
});

export const getActiveAcademicYearsSuccess = (years) => ({
    type: GET_ACTIVE_ACADEMIC_YEARS_SUCCESS,
    payload: years,
});

export const getActiveAcademicYearsFail = (error) => ({
    type: GET_ACTIVE_ACADEMIC_YEARS_FAIL,
    payload: error,
});